"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//
// [NOTE]: Demo mode carries various restrictions and does not:
//       (1) verify R/W permissions.
//       (2) carry an audit log.
//       (3) support root operations.
//       (4) encrypt any data.
//
exports.Demo = {
    ActivitySpec: [],
    SensorSpec: [],
    Researcher: [],
    Study: [],
    Participant: [],
    Activity: [],
    Sensor: [],
    ActivityEvent: [],
    SensorEvent: [],
    Credential: [],
    Tags: []
};
